export enum Route {
  ROOT = '/',
  ERROR = '/error',
  HOME = '/:selectedChannel',

  PROFILE = '/:selectedChannel/profil',
  ACCEPT_RELATIONSHIP = '/association/:uuid',

  COMMUNICATE = '/:selectedChannel/communiquer',
  POSTCARD = '/:selectedChannel/communiquer/carte-postale',
  VIDEO_CALL_LIST = '/:selectedChannel/communiquer/visio/',
  VIDEO_CALL = '/:selectedChannel/communiquer/visio/:videoCallID',
  VIDEO_CALL_PAGE = '/communiquer/visio/:videoCallID/:tabletUserFullName/:selectedChannel/:participantEmail',
  VIDEO_CALL_PAGE_EXPIRED = '/communiquer/visionotfound',
  VIDEO_CALL_PAGE_WITH_CHANNEL = '/:selectedChannel/communiquer/visio/:videoCallID',

  SHARE = '/:selectedChannel/partager',

  ORGANIZE = '/:selectedChannel/organiser',

  FAMILY_PORTAL_TUTORIALS = '/:selectedChannel/accompagner/documents-aide/tutoriels-site-famille',
  GETTING_STARTED = '/:selectedChannel/accompagner/documents-aide/guides-de-demarrage',
  HELP = '/:selectedChannel/accompagner',
  HELP_DOCUMENTS = '/:selectedChannel/accompagner/documents-aide',
  PARTNER_CONTENTS = '/:selectedChannel/contenus-partenaire/:partnerId',
  PARTNER_LIST = '/:selectedChannel/partenaires',
  TABLET_TUTORIALS = '/:selectedChannel/accompagner/documents-aide/tutoriels-ardoiz',
  TEAMVIEWER = '/:selectedChannel/accompagner/teamviewer',

  ADMIN = '/:selectedChannel/administration',
  ADMIN_MESSAGES = '/:selectedChannel/administration/messages',
  ADMIN_MESSAGE_VIEWER = '/:selectedChannel/administration/messages/:key',
  ADMIN_WORKBOOK = '/:selectedChannel/administration/classeur',
  ADMIN_ORGANIZER = '/:selectedChannel/administration/agenda',
  ADMIN_BOOKMARKS = '/:selectedChannel/administration/favoris',
  ADMIN_APPLICATIONS = '/:selectedChannel/administration/applications',
  ADMIN_CONTACTS = '/:selectedChannel/administration/contacts',

  ADMIN_SETTINGS_GENERAL_USER_INFOS = '/:selectedChannel/administration/reglages/general/utilisateur',
  ADMIN_SETTINGS_GENERAL_ACCOUNT_INFOS = '/:selectedChannel/administration/reglages/general/compte',
  ADMIN_SETTINGS_APPLICATION_COMMUNICATE = '/:selectedChannel/administration/reglages/applications/communiquer',
  ADMIN_SETTINGS_APPLICATION_CONTENT = '/:selectedChannel/administration/reglages/applications/contenus',
  ADMIN_SETTINGS_APPLICATION_ACTU = '/:selectedChannel/administration/reglages/applications/actualite',
  ADMIN_SETTINGS_APPLICATION_TV = '/:selectedChannel/administration/reglages/applications/tv',
  ADMIN_SETTINGS_APPLICATION_SPACES = '/:selectedChannel/administration/reglages/applications/espaces',
  ADMIN_SETTINGS_TABLET_DISPLAY = '/:selectedChannel/administration/reglages/applications/affichage',
  ADMIN_SETTINGS_TABLET_SOUND = '/:selectedChannel/administration/reglages/applications/son',
  ADMIN_SETTINGS_TABLET_SYSTEM = '/:selectedChannel/administration/reglages/applications/systeme',
  ADMIN_SETTINGS_TABLET_ACCESSIBILITY = '/:selectedChannel/administration/reglages/applications/accessibilite',
  ADMIN_SETTINGS_TABLET_ADVANCED = '/:selectedChannel/administration/reglages/applications/avance',

}

export default Route;

export enum Params {
  KEY = 'key',
  PARTNER_ID = 'partnerId',
  SELECTED_CHANNEL = 'selectedChannel',
  UUID = 'uuid',
  VIDEO_CALL_ID = 'videoCallID',
}

export type ParamsToReplaceType = Partial<Record<Params, string>>;

const reduceParams = (
  currentRoute: string,
  tuple: [string, string],
): string => {
  const [key, value] = tuple;
  const replaceValue = value ? `/${value}` : value;

  return currentRoute.replace(`/:${key}`, replaceValue);
};

export const replaceRouteParams = (
  route: Route,
  paramsToReplace: ParamsToReplaceType,
): string => Object.entries(paramsToReplace).reduce(reduceParams, route);
